import client from "./client";

export const sendFeedback = ({answerId, type, optionList, inputText}) =>
    client.post('/api/chat/feedback', {answerId, type, optionList, inputText});
